export default "__VITE_PUBLIC_ASSET__5a9fa879__"